import { useTranslation } from 'react-i18next';

import { Flex, Text } from '@valwin/facto/components';
import { Page } from '@valwin/facto/widgets';

export function AccessDenied() {
  const { t } = useTranslation();

  return (
    <Page.Root>
      <Page.Header title="" />
      <Page.Main>
        <Flex
          flexDirection="column"
          alignItems="center"
          justifyContent="center"
          flex={1}
          paddingX={16}
          paddingY={8}
          height="100%"
        >
          <Text textStyle="xl" fontWeight="bold" margin="0">
            403
          </Text>
          <Text textStyle="md">{t('errors accessDenied')}</Text>
        </Flex>
      </Page.Main>
    </Page.Root>
  );
}
